module.exports = __webpack_public_path__ + "static/media/individual.872ab2be.svg";